var map = {
	"./arg.svg": 859,
	"./aus.svg": 860,
	"./bel.svg": 861,
	"./bra.svg": 862,
	"./can.svg": 863,
	"./cmr.svg": 864,
	"./crc.svg": 865,
	"./cro.svg": 866,
	"./den.svg": 867,
	"./ecu.svg": 868,
	"./eng.svg": 869,
	"./esp.svg": 870,
	"./fra.svg": 871,
	"./ger.svg": 872,
	"./gha.svg": 873,
	"./irn.svg": 874,
	"./jpn.svg": 875,
	"./kor.svg": 876,
	"./ksa.svg": 877,
	"./mar.svg": 878,
	"./mex.svg": 879,
	"./ned.svg": 880,
	"./pol.svg": 881,
	"./por.svg": 882,
	"./qat.svg": 883,
	"./sen.svg": 884,
	"./srb.svg": 885,
	"./sui.svg": 886,
	"./tun.svg": 887,
	"./uru.svg": 888,
	"./usa.svg": 889,
	"./wal.svg": 890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2536;